import { z } from 'zod'
import { MonitoredArea } from '../../../domain/entities/MonitoredArea'
import { GeometrySchema } from '../../../../@shared/infra/schemas/Geometry.schema'

const isInvalidGeometryString = (value: unknown): value is null | undefined | '' | 'undefined' =>
	typeof value !== 'string' || value === '' || value === 'undefined'

export const MonitoredAreaSchema = z
	.object({
		id: z.uuid(),
		nome: z.string(),
		geometria: z.preprocess((value) => {
			const parsed = JSON.parse(value as string)
			return GeometrySchema.parse(parsed)
		}, GeometrySchema),
		buffer: z
			.preprocess((value) => {
				if (isInvalidGeometryString(value)) return undefined
				const parsed = JSON.parse(value as string)
				return GeometrySchema.parse(parsed)
			}, GeometrySchema)
			.optional(),
	})
	.transform((data) => {
		return new MonitoredArea(data.id, data.nome, data.geometria, data.buffer)
	})
